import { createAction, props } from "@ngrx/store";
import { ModalType } from "../enums/modals/modalType";

export const showModal = createAction('showModal', props<{wrapperCssClasses: string, modalType : ModalType, data? : any}>())
export const hideModal = createAction('hideModal')